import { createInstance, ReactSDKClient } from '@optimizely/react-sdk';
import Cookies from 'js-cookie';
import config from './config';

const optimizelyClient: ReactSDKClient = createInstance({
  sdkKey: config.optimizelyKey,
});

export function optimizelySetUser(id: string | null | undefined): void {
  if (id) {
    optimizelyClient.setUser({ id });
  } else {
    console.warn('[OPTIMIZELY-WEB] setUser: id is empty');
  }
}

export function optimizelyTrack(eventName: string): void {
  if (optimizelyClient.user?.id) {
    optimizelyClient.track(eventName);
  } else {
    console.warn('[OPTIMIZELY-WEB] track: userid is not set');
  }
}

export function getOptimizelyUserId(): string {
  return Cookies.get('OPTIMIZELY_USER_ID') || '';
}

export default optimizelyClient;
